module.exports = __webpack_public_path__ + "img/hryvna-gray-circle.3bc87d90.svg";